import AsideMenu from './AsideMenu';

export default AsideMenu;
